import type { BridgeHandlerMap, BridgeHandlerName } from './types'

type MockHandlerMap = {
  [K in BridgeHandlerName]: (
    ...args: BridgeHandlerMap[K]['args'] extends void ? [] : [BridgeHandlerMap[K]['args']]
  ) => BridgeHandlerMap[K]['response']
}

const DEFAULT_MOCK_HANDLERS: MockHandlerMap = {
  healthCheck: () => ({ status: 'ok', timestamp: new Date().toISOString() }),
  getToken: () => ({ token: 'dev-mock-token', bottom: '0' }),
  // [EXPERIMENT] isNewUserEvent: dev 에서 AvailableBenefitStep 노출 확인 편의 위해 true.
  // 실험 종료 시 필드 제거.
  getUserInfo: () => ({ userId: 'dev-user-1', nickname: '테스트유저', isNewUserEvent: true }),
  shareLink: () => ({ shared: true }),
  haptic: () => undefined as never,
  closeWebView: () => undefined as never,
  openBottom: ({ type }) => ({ type }),
  onNextRouter: () => undefined as never,
  enterServiceArea: () => undefined as never,
  onApply: () => undefined as never,
  openServiceArea: () => undefined as never,
  onError: () => undefined as never,
  // ─── [EXPERIMENT] 혜택 플로우 실험 — 종료 시 두 항목 제거 ───
  getServiceAvailability: () => ({
    address: '충청북도 청주시 청원구 우암동',
    isAvailable: false,
    waitingCount: 152,
  }),
  onPushAddressForm: () => undefined as never,
  // ───────────────────────────────────────────────────────────
  // ─── [핸들러 규약 v2 — 2026-05-15] 신규 mock ────────────────
  getAuthToken: () => ({
    accessToken: 'dev-mock-access-token',
    refreshToken: 'dev-mock-refresh-token',
  }),
  getDeviceInfo: () => ({
    topPadding: 0,
    bottomPadding: 0,
    deviceHeight: 812,
    deviceWidth: 375,
  }),
  onSyncError: () => ({ isSuccess: true }),
  onNext: () => ({ isSuccess: true }),
  onPrevious: () => ({ isSuccess: true, pages: 1 }),
  on_payment_method_refresh: () => undefined as never,
  // ─────────────────────────────────────────────────────────────
}

export function setupBridgeMock(overrides?: Partial<MockHandlerMap>) {
  if (window.flutter_inappwebview) return

  const handlers = { ...DEFAULT_MOCK_HANDLERS, ...overrides }

  window.flutter_inappwebview = {
    callHandler: async (handlerName: string, ...args: unknown[]) => {
      const handler = handlers[handlerName as BridgeHandlerName]
      if (!handler) {
        console.warn(`[Bridge Mock] Unknown handler: ${handlerName}`)
        return undefined
      }
      console.log(`[Bridge Mock] ${handlerName}`, args.length > 0 ? args : '')
      return handler(...(args as [never]))
    },
  }

  window.dispatchEvent(new Event('flutterInAppWebViewPlatformReady'))
  console.log('[Bridge Mock] Mock bridge initialized')
}
